import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import enums from './modules/enums'
import dashboard from './modules/dashboard'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    enums,
    dashboard,
  },
})
